import request from '../utils/request'


const permissionService = {

    // 获取机构所有权限
    getAllPermissionsByTenantId: (tenantId) => {
        return request({
            url: '/permission/tenantId',
            method: 'post',
            data: {tenantId}
        })
    },

    getPermissionsByRoleId: (roleId) => {
        return request({
            url: '/permission/roleId',
            method: 'post',
            data: {roleId}
        })
    },
    // 新增权限
    addPermission: (permission) => {
        return request({
            url: '/api/permission',
            method: 'post',
            data: permission
        })
    },

    // 更新权限
    updatePermission: (permission) => {
        return request({
            url: '/api/permission',
            method: 'put',
            data: permission
        })
    },

    // 删除权限
    deletePermission: (id) => {
        return request({
            url: `/api/permission/${id}`,
            method: 'delete'
        })
    },

    // 为角色分配权限（覆盖原assignPermissions方法）
    assignPermissions: (roleId, permissionIds) => {
        return request({
            url: `/permission/updateRolePermission`, // 使用统一的API前缀
            method: 'post',
            data: { roleId, permissionIds }
        })
    }
}

export default permissionService
